<!--
  name : 이예닮
  desc : (회원)보관함-상세
  date : 2022-01-14
-->
<template>
  <v-container class="con_mpw"
    v-model="dialogIdtest">
    <v-row no-gutters class="mem_W_detail">
      <!-- 상세 상단 - 계약상태 / 최종수정일 / 파일명 / 계약요청/수신자 정보 / 인쇄, 다운로드 버튼 -->
      <v-col cols="12" class="docuD_pop_title align-start">
        <div class="boxTcon">
            <div class="infoFCon">
              <!--↓ 계약상태
              /*취소 / st01:검토 요청 / st02:내 서명 대기 / st03:서명 진행 / st04:서명 거부 / st05:완료 / st06:임시저장 **/-->
              <div class="carD_chip00" v-if="contractDetailInfo.contractStatus == 'PR'">
                <v-chip class="st01">검토 요청</v-chip><!--계약 상태
                ***상태별 텍스트 변경***  /*취소 / st01:검토 요청 / st02:내 서명 대기 / st03:서명 진행 / st04:서명 거부 / st05:완료 / st06:임시저장 **/-->
              </div>
              <div class="carD_chip00" v-else-if="contractDetailInfo.contractStatus == 'CR' &&  getAddress (contractDetailInfo.receiverAddress)">
                <v-chip class="st02">내 서명 대기</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contractDetailInfo.contractStatus == 'CR' &&  getAddress (contractDetailInfo.senderAddress)">
                <v-chip class="st03">서명 진행</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contractDetailInfo.contractStatus == 'CN'">
                <v-chip class="st04">서명 거부</v-chip>
              </div>
              <div class="carD_chip00" v-else-if="contractDetailInfo.contractStatus == 'CC'">
                <v-chip class="st05">완료</v-chip>
              </div>
              <!--↓ 파일명-->
              <div class="carD_01_txt">
                <!--계약명--><span class="st_tt_01">{{contractDetailInfo.contractFileName}}</span>
                <!--↓ 최종수정일-->
                <div class="dateBox">
                  <span class="st_txt">{{contractDetailInfo.sentDatetime}}</span>
                </div>
              </div>
            </div>
        </div>
        <div class="boxBtn">
            <!--↓ (버튼)파일을 인쇄함-->
            <!--<v-btn class="btn18_00" outlined @click="print()">
            <span class="btn-icon_print"></span>인쇄</v-btn>-->
            <!--↓ (버튼)파일을 다운로드함-->
            <v-btn class="btn18_00" outlined @click="downloadPDF()">
            <span class="btn-icon_download"></span>다운로드</v-btn>
            <!--↓ (버튼)팝업 닫음 - 비회원시 가리기
            <v-btn class="btn_pop_closeTop" icon @click="dialog = false, sheet = false">
            <span class="icon"></span>
            </v-btn>-->
        </div>
        <!-- 요청/수신자 정보 -->
          <div class="docuD_pop_tcp_box">
            <ul class="pattern_ulTxtBox_conV" v-if="contractDetailInfo.contractStatus == 'CN' || contractDetailInfo.contractStatus == 'CC'">
              <li>
                <!--↓ (고정)타이틀-->
                <span class="txt_icon">요청</span>
		            <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)회사이름-->
                <span class="txt_con">{{contractDetailInfo.receiverName}}</span>
		            <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)이름-->
                <span class="txt_icon" v-if="contractDetailInfo.receiverBrokerName != null">요청 대행자</span>
                <span class="txt_con" v-if="contractDetailInfo.receiverBrokerName != null">{{contractDetailInfo.receiverBrokerName}}</span>
              </li>
              <li>
                <!--↓ (고정)타이틀-->
                <span class="txt_icon">수신</span>
		            <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)이름-->
                <span class="txt_con">{{contractDetailInfo.senderName}}</span>
                <span class="txt_icon" v-if="contractDetailInfo.senderBrokerName != null">수신 대행자</span>
                <span class="txt_con" v-if="contractDetailInfo.senderBrokerName != null">{{contractDetailInfo.senderBrokerName}}</span>
              </li>
            </ul>
            <ul class="pattern_ulTxtBox_conV" v-else>
              <li>
                <!--↓ (고정)타이틀-->
                <span class="txt_icon">요청</span>
		            <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)회사이름-->
                <span class="txt_con">{{contractDetailInfo.senderName}}</span>
		            <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)이름-->
                <span class="txt_icon" v-if="contractDetailInfo.senderBrokerName != null">요청 대행자</span>
                <span class="txt_con" v-if="contractDetailInfo.senderBrokerName != null">{{contractDetailInfo.senderBrokerName}}</span>
              </li>
              <li>
                <!--↓ (고정)타이틀-->
                <span class="txt_icon">수신</span>
		            <!--↓ (변동-타이틀 후에오는 모든 텍스트는 아래 class로 처리)이름-->
                <span class="txt_con">{{contractDetailInfo.receiverName}}</span>
                <span class="txt_icon" v-if="contractDetailInfo.receiverBrokerName != null">수신 대행자</span>
                <span class="txt_con" v-if="contractDetailInfo.receiverBrokerName != null">{{contractDetailInfo.receiverBrokerName}}</span>
              </li>
            </ul>
          </div>
          <!-- /요청/수신자 정보 -->
          <!-- 기타 정보 -->
          <div class="pd-0">
            <ul class="pattern_ulTxtBox li_mg01">
              <li v-if="contractDetailInfo.rejectMessage !== null && contractDetailInfo.rejectMessage !== undefined">
                <span class="txt_tt03 fc_C05">[거부사유]</span>
                <span class="txt_txt01">{{ contractDetailInfo.rejectMessage }}</span>
              </li>
              <li class="info_requestor" v-if="attachedFiles.length <= 0">
                <span class="txt_tt03">[첨부파일]</span>
                <span class="txt_txt01">첨부파일이 없습니다.</span>
              </li>
              <li class="info_requestor" v-else v-for="(item, index) in attachedFiles"
            :key="index"
            @click.prevent="downloadAttachFile(item)">
            <span class="txt_tt03">[첨부파일]</span>
            <a class="a_file_down" href="#" target="_blank">
                <span class="txt_txt01">{{item.fileName}}</span>
                <span class="txt_txt03 no_pr">{{item.fileSize | fileSizeFilter}}</span>
                <span class="icon_down"></span>
            </a>
              </li>
            </ul>
          </div>
        <!-- /기타 정보 -->
     </v-col>
     <!-- <contract-info :signal="signal" :contractDetailInfo="contractDetailInfo === null?'':contractDetailInfo"  :attachedFiles="attachedFiles"></contract-info>-->
      <!-- /상세 상단 -->
      <!-- 내용 -->
      <v-col cols="12" class="docuD_pop_con">
        <v-row no-gutters>
          <v-col class="docuDpreVCol" cols="12" sm="12" md="6" lg="6" v-if="preview">
            <!--미리보기-->
            <v-responsive :aspect-ratio="10/14" class="docuDpreVbox before_bcpw">
              <v-btn class="btn19_C01" @click="previewCert">미리보기</v-btn>
              <v-img src="/assets/img/bcpw_thumbnaill_img.png"></v-img>
            </v-responsive>
          </v-col>
          <v-col v-model="pdfview" class="docuDpreVCol" cols="12" sm="12" md="12" lg="6" v-else>
            <div class="docuDpreVbox">
              <pdf-preview v-show="contract" ref="pdfPreview" :scale="1" :key="componentKey"></pdf-preview>
            </div>
          </v-col>
      <v-col class="docuDcon02Col" cols="12" sm="12" md="6" lg="6">
        <v-row no-gutters class="gridM_left30 gridM_left0_md w100h100">
      <!-- 각지정보 - 모바일에서는 디폴트-닫힘 -->
          <v-col class="docuDcmtBox" cols="12">
            <v-card-actions class="fabS44">
              <v-list-item-title class="fs18_fc98">갑지정보</v-list-item-title>
              <v-spacer></v-spacer>
              <v-btn fab @click="show1=show1?false:true">
                <!--내용이 닫혀 있을 때 아이콘-->
                <span class="icon_arr_s_g_u" v-if="show1"></span>
                <!--내용이 열려 있을 때 아이콘-->
                <span class="icon_arr_s_g_d" v-else></span>
              </v-btn>
            </v-card-actions>
            <v-expand-transition>
              <v-card-text v-show="show1">
                <!-- 각지정보 내용 -->
                <div v-if="subInfo <= 0">
                  <ul class="subinfoPCon">
                    <li>
                      부가정보가 없습니다.
                    </li>
                  </ul>
                </div>
                <div v-else>
                  <ul class="subinfoPCon" v-for="(info, index) in subInfo" :key="index">
                    <li>
                      <!--↓ (고정)타이틀-->
                      <span class="txt_type_title">{{info.key}}</span>
                      <!--↓ (고정)내용-->
                      <span class="txt_type_txt">{{info.value}}</span>
                    </li>
                  </ul>
                </div>
                <!-- /각지정보 내용 -->
              </v-card-text>
            </v-expand-transition>
          </v-col>
      <!-- /각지정보 -->
      <!-- 계약로그 - 모바일에서는 디폴트-닫힘 -->
          <v-col class="docuDlogBox" cols="12">
            <v-card-actions class="fabS44">
              <v-list-item-title class="fs18_fc98">계약로그</v-list-item-title>
              <v-spacer></v-spacer>
              <v-btn fab @click="show2=show2?false:true">
                <!--내용이 닫혀 있을 때 아이콘-->
                <span class="icon_arr_s_g_u" v-if="show2"></span>
                <!--내용이 열려 있을 때 아이콘-->
                <span class="icon_arr_s_g_d" v-else></span>
              </v-btn>
            </v-card-actions>
            <v-expand-transition>
              <v-card-text class="box_log" v-show="show2">
                <div v-if="contractHistory <= 0">
                  <ul class="subinfoPCon">
                    <li>
                      계약로그가 없습니다.
                    </li>
                  </ul>
                </div>
                <div v-else>
                  <ul v-for="(history, index) in contractHistory" :key="index">
                    <li>
                      <div class="box_log_icon"  v-if="history.ctrStat == 'CR'">
                        <!--계약로그 상태 icon-->
                        <!--class=
                          (고정)log_cer_icon
                          (상태에 따라)
                          type01_01
                          CC 계약승인 | PC 검토승인 = type01_02 / CN 승인거부 = type01_03
                          CR 계약요청 = type02_01 / CA 계약요청 취소 = type02_02
                          검토요청 = type03_01 / PN 검토요청 거부 = type03_02
                          DW 다운로드 = type04_01 / LA 열람인증 = type04_02
                        -->
                        <!--계약로그 상태-->
                            <span class="log_icon type02_01"></span>
                            <span class="txt_ing">{{CtrRecord(history.ctrStat)}}</span>
                      </div>
                      <div class="box_log_icon"  v-else-if="history.ctrStat == 'CC' || history.ctrStat == 'PC'">
                          <span class="log_icon type01_02"></span>
                          <span class="txt_ing">{{CtrRecord(history.ctrStat)}}</span>
                      </div>
                      <div class="box_log_icon"  v-else-if="history.ctrStat == 'CN'">
                          <span class="log_icon type01_03"></span>
                          <span class="txt_ing">{{CtrRecord(history.ctrStat)}}</span>
                      </div>
                      <div class="box_log_icon"  v-else-if="history.ctrStat == 'CA'">
                          <span class="log_icon type02_02"></span>
                          <span class="txt_ing">{{CtrRecord(history.ctrStat)}}</span>
                      </div>
                      <div class="box_log_icon"  v-else-if="history.ctrStat == 'PR'">
                          <span class="log_cer_icon type03_01"></span>
                          <span class="txt_ing">{{CtrRecord(history.ctrStat)}}</span>
                      </div>
                      <div class="box_log_icon"  v-else-if="history.ctrStat == 'PN'">
                          <span class="log_icon type03_02"></span>
                          <span class="txt_ing">{{CtrRecord(history.ctrStat)}}</span>
                      </div>
                      <div class="box_log_icon"  v-else-if="history.ctrStat == 'DW'">
                          <span class="log_icon type04_01"></span>
                          <span class="txt_ing">{{CtrRecord(history.ctrStat)}}</span>
                      </div>
                      <div class="box_log_icon"  v-else-if="history.ctrStat == 'LA'">
                          <span class="log_icon type04_02"></span>
                          <span class="txt_ing">{{CtrRecord(history.ctrStat)}}</span>
                      </div>
                      <div class="box_log_icon"  v-else>
                          <span class="log_icon type01_01"></span>
                          <span class="txt_ing">{{CtrRecord(history.ctrStat)}}</span>
                      </div>
                      <div class="box_log_txt">
                        <!--해당 담당자-->
                        <span class="txt_name">{{history.crecDesc}}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </v-card-text>
            </v-expand-transition>
          </v-col>
          <!-- /계약로그 -->
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- /내용 -->
      <v-col cols="12">
      <v-row no-gutters v-model="sheet" persistent hide-overlay :no-click-animation="true">
        <v-col cols="12" class="docu_btnCon" v-if="contractDetailInfo.contractStatus === 'CR'" >
          <!-- 사조 채권재무 계약서일 경우 -->
          <div v-if="formCode === 'D02'">
            <v-btn outlined class="btn19_00 btnC_00" v-if="!isSender"  @click="chainAuthVisible('downloadCC')">일치</v-btn>
            <v-btn outlined class="btn19_00 btn_ol_C05" v-if="!isSender" @click="chainAuthVisible('CN')">불일치</v-btn>
            <v-btn outlined class="btn19_00" @click="listGo">목록가기</v-btn>
          </div>
          <div v-else>
            <v-btn outlined class="btn19_00 btnC_00" v-if="!isSender"  @click="chainAuthVisible('downloadCC')">계약승인</v-btn>
            <v-btn outlined class="btn19_00 btn_ol_C05" v-if="!isSender" @click="chainAuthVisible('CN')">승인거부</v-btn>
            <v-btn outlined class="btn19_00 btn_ol_C05" v-if="isSender && !LbpYn" @click="chainAuthVisible('CA')">요청취소</v-btn>
            <v-btn outlined class="btn19_00" @click="listGo">목록가기</v-btn>
            <v-btn outlined class="btn19_00" v-if="isSender" @click="emailResend()">이메일 재전송</v-btn>
          </div>
        </v-col>
        <v-col cols="12" class="docu_btnCon" v-else-if="contractDetailInfo.contractStatus === 'PR'" >
          <v-btn outlined class="btn19_00 btnC_00" v-if="!isSender"  @click="chainAuthVisible('downloadPC')">검토승인</v-btn>
          <v-btn outlined class="btn19_00 btn_ol_C05" v-if="!isSender"  @click="chainAuthVisible('PN')">검토거부</v-btn>
          <v-btn outlined class="btn19_00 btn_ol_C05" v-if="isSender" @click="chainAuthVisible('PA')">요청취소</v-btn>
          <v-btn outlined class="btn19_00" @click="listGo">목록가기</v-btn>
        </v-col>
        <v-col cols="12" class="docu_btnCon" v-else >
          <v-btn outlined class="btn19_00" @click="listGo">목록가기</v-btn>
        </v-col>
      </v-row>
      </v-col>
    </v-row>

  <!--결제-기업-->
    <v-dialog
      v-model="payEnd"
      max-width="600px"
      persistent>
      <v-card id="popStyle02">
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <v-col cols="12" class="ta_center row_mb-40">
              <div class="payEnd_view" v-if="signal === 'BROKER'">
                <span class="icon01"></span>
                <span class="txt01">요금정보</span>
                <span class="txt02">
                  <span class="txtst_info_gray mr-2">차감</span><span class="txtst_info_red">{{ usePoint }}p</span> / <span class="txtst_info_gray mr-2">잔여</span><span class="fc_C03">{{ totalPoint }}</span>
                </span>
              </div>
              <div>계약요청이 완료 되었습니다.<br>미처리함으로 이동하시겠습니까?</div>
            </v-col>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text @click="payEndMove('write')">계약작성</v-btn>
          <!--미처리함 이동-->
          <v-btn text @click="payEndMove('storage')">미처리함</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <!--/결제-기업-->
  <s-confirm ref="confirm"></s-confirm>
  <s-loading ref="loading"></s-loading>
  <ctr-reqeust-dialog ref="ctrReqeustDialog" :contractDetailInfo="contractDetailInfo" :authDialog="authDialog" :convertedInfo="convertedInfo" :signal="signal" :purCertInfo="purCertInfo" :cPass="cPass" @childs-event="goList"></ctr-reqeust-dialog>
  <pubCert ref="pubCert" :certRegno="purCertInfo.certRegNo" :hash="purCertInfo.hash"  @childs-event="purCertResult"></pubCert>
  <chainPass ref="chainPass" :chain-address="this.contractDetailInfo.chainAddress" @chainPassEvent="chainPassResult"></chainPass>
  <rejectMessage ref="rejectMessage" @rejectEvent="rejectResult" :isMismatchForm="isMismatchForm" :formCode="formCode"></rejectMessage>
  <pgRequest ref="pgRequest" :contractDetailInfo="contractDetailInfo" :signal="signal" @pgEvent="pgResult"></pgRequest>
  <emailResend ref="emailResend" :emailRty="emailRty"></emailResend>
  </v-container>
</template>
<script>
import ctrReqeustDialog from '@/views/contract/contractDetail/components/ctrReqeustDialog'
import { getContractDetail, downloadFile, changeStatus, changeStatusForReviewApprove, changeStatusForApprove, getContractRecord } from '@/api/contract/contractDetail'
import { verifyChain } from '@/api/contract/V2ContractDetail'
import PubCert from "@/components/pubCert"
import ChainPass from "@/components/chainPass"
import PgRequest from "@/views/contract/contractDetail/components/pgRequest"
import emailResend from "@/views/contract/contractDetail/components/emailResend"
import PdfPreview from "@/components/pdfPreview"
import RejectMessage from "@/components/rejectDialog"
import { confirmCurrPoint } from '@/api/payment/payment'

export default {
  name: 'sajoDetail',
  props:{
    contractNumber: String,
    contractSeq : Number,
    certRegNo: String
  },
  components: {
    ctrReqeustDialog,
    PubCert,
    ChainPass,
    RejectMessage,
    PdfPreview,
    PgRequest,
    emailResend
  },
  filters: {
    // 용량에 따른 파일 크기 포맷 변경
    fileSizeFilter (fileSize) {
      var filterFileSize = 0
      if (fileSize >= 1000000) {
        filterFileSize = parseInt(fileSize / 1000000) + 'MB'
      } else if (fileSize >= 1000) {
        filterFileSize = parseInt(fileSize / 1000) + 'KB'
      } else {
        filterFileSize = fileSize + 'KB'
      }
      return filterFileSize
    }
  },
  data () {
    return {
      // 상세 다이얼로그
      dialogIdtest: true,
      // 갑지정보 여닫
      show1: true,
      // 계약로그 여닫
      show2: true,
      // 하단 버튼 고정
      sheet: true,
      chainAuthDialog: false,
      preview: true,
      payEnd: false,
      ctrSeq: '',
      // 계약서 정보
      contractDetailInfo: {
        id:'',
        contractNumber: '',
        contractFileName: '',
        senderName: '',
        receiverName: '',
        senderAddress: '',
        receiverAddress: '',
        senderBrokerName: '',
        sentDatetime: '',
        chainAddress: '',
        chainPassword: '',
        contractFileLink: '',
        contractStatus: '',
        rejectMessage: ''
      },
      // contractDetailInfo: null,
      // 기업계약인지 개인계약인지 여부 확인
      signal: '',
      // 부가정보 리스트
      subInfo: [],
      // 첨부 파일 리스트
      attachedFiles: [],
      contractHistory: [],
      // 계약서 썸네일
      contractThumbnail: {
        pageSize: null,
        thumbnail: []
      },
      // PDF로 변환된 파일 정보
      convertedInfo: {
        downloadTempPath: null,
        convertedCtrFileName: null,
        contractNumber: null
      },
      // 워터마크들
      watermarks: [],
      downloadParam: {
        chainAddr: null,
        chainPass: null,
        downloadUrl: null,
        contractNumber: null,
        contractFileName: null,
        gubun: null,
        receiverName: null,
        receiverAddress: null,
      },
      // 워터마크 첨부 여부
      isWmAttach: false,
      url: {
        confirmDownloadURL: process.env.VUE_APP_URL_CONFIRM_DOWNLOAD_URL
      },
      downloadFileInfo: null,
      // 블록체인 인증 창 타이틀 / 인증자 / 알림 문구 / 상태변경 메시지 / 상태 플래그
      authDialog: {
        title: '',
        authUserText: '',
        warningText: '',
        changeStatusText: '',
        changeStatus: ''
      },
      pdfFileName: null,
      purCertInfo:{
        certRegNo:'',
        hash: ''
      },
      ctrInfo:{
        contractNumber: '',
        contractSeq: '',
        ctrLockType:'',
        failCnt:'',
        stat: '',
        signType: '0',
        acqDate: '',
        resultCode: ''
      },
      chainPassCheck: '',
      contract: {},
      componentKey: 0,
      usePoint: 0,
			totalPoint: 0,
      cPass: '',
      emailRty:{
        receiverName: '',
        receiverEmail: '',
        ownerAddress: '',
        ctrStatus: '',
        ctrNo: ''
      },
      LbpYn: false,
      formCode: '',
      isMismatchForm: false
    }
  },
  created () {
  },
  mounted () {
    this.track()
		if (!this.$route.params.contractSeq) {
      // 계약서 시퀀스가 없으면 미처리함으로 이동시킨다.
      // this.openAlertMessage('계약서 정보가 없습니다.', '계약상세', 'provision')
      this.movePage('storage')
    } else {
      this.$nextTick(() => {
        this.getContractDetail()
      })
    }
  },
  methods: {
    track () {
      this.$gtag.pageview({
        page_path: '/contrackDetail'
      })
    },
    getAddress (address) {
      var orgname = this.$store.state.user.orgname
      var orgaddr = this.$store.state.user.orgaddr
      var useraddr = this.$store.state.user.useraddr
      if (orgname) {
        if(orgaddr === address) {
          return true
        }else{
          return false
        }
      } else {
        if(useraddr === address) {
          return true
        }else{
          return false
        }
      }
    },
    getContractDetail () {
			this.contractDetailInfo.id = this.contractSeq
      getContractDetail({ ctrSeq: this.contractSeq }).then(response => {
        if (response.rdata.rcode === 20000) {
          this.contractDetailInfo = response.rdata.detailInfo

          if(response.rdata.detailInfo.ownerAddress === response.rdata.detailInfo.senderAddress) {
            if(response.rdata.detailInfo.senderBrokerName !== "" && response.rdata.detailInfo.senderBrokerName !== null) {
              this.downloadParam.receiverName = response.rdata.detailInfo.senderName + ' ' + response.rdata.detailInfo.senderBrokerName
              this.downloadParam.receiverAddress = response.rdata.detailInfo.senderBrokerAddress
            }else {
              this.downloadParam.receiverName = response.rdata.detailInfo.senderName
              this.downloadParam.receiverAddress = response.rdata.detailInfo.ownerAddress
            }
          }else if (response.rdata.detailInfo.ownerAddress === response.rdata.detailInfo.receiverAddress) {
            if(response.rdata.detailInfo.receiverBrokerName !== "" && response.rdata.detailInfo.receiverBrokerName !== null) {
              this.downloadParam.receiverName = response.rdata.detailInfo.receiverName + ' ' + response.rdata.detailInfo.receiverBrokerName
              this.downloadParam.receiverAddress = response.rdata.detailInfo.receiverBrokerAddress
            }else {
              this.downloadParam.receiverName = response.rdata.detailInfo.receiverName
              this.downloadParam.receiverAddress = response.rdata.detailInfo.ownerAddress
            }
          }

          this.contractDetailInfo.chainAddress = response.rdata.detailInfo.ownerAddress
          this.purCertInfo.certRegNo = response.rdata.certNo
          this.ctrInfo.stat = response.rdata.stat

          this.contractDetailInfo.contractStatus = response.rdata.detailInfo.contractStatus
          // this.contractDetailInfo = response.rdata.detailInfo
          this.signal = response.rdata.signal

          // 이메일 재전송 관련
          this.emailRty.ctrNo = response.rdata.detailInfo.contractNumber
          if(this.emailRty.ctrNo.indexOf("LBP-") !== -1) {
            this.LbpYn = true
          }
          this.emailRty.ctrStatus = response.rdata.detailInfo.contractStatus
          this.emailRty.ownerAddress = response.rdata.detailInfo.ownerAddress
          this.emailRty.receiverName = response.rdata.name
          this.emailRty.receiverEmail = response.rdata.email

          if(response.rdata.detailInfo.senderAddress === this.$store.state.user.orgaddr || response.rdata.detailInfo.senderAddress === this.$store.state.user.useraddr) {
            this.isSender = true
          }
          // 첨부 파일은 없을 수도 있기 때문에 값이 있을 때만 넣어줘야함
          if (response.rdata.attachedFile) {
            this.attachedFiles = response.rdata.attachedFile
          }
          this.contractHistory = response.rdata.contractHistory

          // 부가 정보는 없을 수도 있기 때문에 값이 있을 때만 넣어줘야함
          if (response.rdata.subInfo) {
            this.subInfo = response.rdata.subInfo
          }
          if (response.rdata.contractHistory) {
            this.contractHistory = response.rdata.contractHistory
          }
          // this.downloadAuthChain()
        } else if (response.rdata.rcode === 30011) {
          this.$refs.confirm.open('alert', '계약상세', '계약상세 조회에 실패했습니다. ( 실패이유 - ' + response.rdata.rmessage + ' )')
        } else {
          this.$refs.confirm.open('alert', '계약상세', '계약상세 조회에 실패 에러 : ' + response.rdata.rmessage)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    previewCert() {
      this.authDialog.changeStatus = "preview"
      this.$refs.chainPass.open()
    },
    downloadPDF () {
      if(this.contractDetailInfo.chainPassword !== '' && this.contractDetailInfo.chainPassword !== undefined) {
        this.downloadParam.chainAddr = this.contractDetailInfo.chainAddress
        this.downloadParam.chainPass = this.contractDetailInfo.chainPassword
        this.downloadParam.downloadUrl = this.contractDetailInfo.contractFileLink
        this.downloadParam.contractNumber = this.contractDetailInfo.contractNumber
        this.downloadParam.contractStatus = this.contractDetailInfo.contractStatus
        this.downloadParam.contractFileName = this.contractDetailInfo.contractFileName
        this.downloadParam.gubun = "DW"
        downloadFile(this.downloadParam).then(response => {
          // poer.close()
          if (response.rdata.rcode === 20000) {
            var downloadFileName = encodeURIComponent(response.rdata.downFileName)
            window.open(
              this.url.confirmDownloadURL +
              '/' + this.downloadParam.gubun +
              '/' + response.rdata.convId +
              '/' + this.downloadParam.downloadUrl,
              '_blank')
            this.getContractRecord()
          } else {
            this.$refs.confirm.open('alert', '계약서 다운로드', '계약서 다운로드 요청에 실패했습니다. ( error : ' + response.rdata.rmessage + ' )')
          }
        })
      }else {
        this.$refs.confirm.open('alert', '계약서 다운로드', '미리보기를 한 후 다운로드가 가능해집니다.')
      }
    },
    downloadAuthChain () {
      this.$refs.loading.start('계약서 다운로드를 진행 중입니다.')
      this.downloadParam.chainAddr = this.contractDetailInfo.chainAddress
      this.downloadParam.chainPass = this.contractDetailInfo.chainPassword
      this.downloadParam.downloadUrl = this.contractDetailInfo.contractFileLink
      this.downloadParam.contractNumber = this.contractDetailInfo.contractNumber
      this.downloadParam.contractStatus = this.contractDetailInfo.contractStatus
      this.downloadParam.contractFileName = this.contractDetailInfo.contractFileName
      this.downloadParam.gubun = "PV"
      downloadFile(this.downloadParam).then(response => {
        this.$refs.loading.end()
        if (response.rdata.rcode === 20000) {
          this.convertedInfo.downloadTempPath = response.rdata.downloadTempPath
          this.convertedInfo.convertedCtrFileName = response.rdata.convId
          this.convertedInfo.contractNumber = this.contractDetailInfo.contractNumber
          var downFile =this.url.confirmDownloadURL +
            '/' + this.downloadParam.gubun +
            '/' + response.rdata.convId +
            '/' + this.downloadParam.downloadUrl

          this.cPass = this.contractDetailInfo.chainPassword
          this.preview = false
          this.getContractRecord()
          this.createContractThumbnail(downFile)
        } else if (response.rdata.rcode === 30011) {
          this.$refs.confirm.open('alert', '계약서 다운로드', '계약서 다운로드 요청에 실패했습니다. ( 실패이유 - ' + response.rdata.rmessage + ' )')
        } else {
          this.$refs.confirm.open('alert', '계약서 다운로드', '계약서 다운로드 요청에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    createContractThumbnail (downFile) {
      this.$nextTick(() => {
        this.$refs.pdfPreview.open(downFile)
      })
    },
    // 블록체인 인증 (승인 / 거부 / 취소 클릭 시)
    chainAuthVisible (changeStatus) {
      this.authDialog.changeStatus = changeStatus

      if((!(this.contractDetailInfo.chainPassword !== '' && this.contractDetailInfo.chainPassword !== undefined)) && changeStatus === 'downloadCC') {
        this.$refs.confirm.open('alert', '계약승인', '미리보기를 한 후 계약승인이 가능합니다.');
        return;
      }

      if((!(this.contractDetailInfo.chainPassword !== '' && this.contractDetailInfo.chainPassword !== undefined)) && changeStatus === 'CN') {
        this.$refs.confirm.open('alert', '승인거부', '미리보기를 한 후 승인거부가 가능합니다.');
        return;
      }

			// 블록체인 인증 창 상태값에 따른 텍스트 변경 및 블록체인 인증 창 활성화
			if (changeStatus === 'CC') {
        this.authDialog.title = '계약승인'
        this.authDialog.authUserText = '계약 수신자'
        this.authDialog.warningText = '블록체인 인증이 완료되어야 계약승인이 완료됩니다.'
        this.authDialog.changeStatusText = '계약 승인 중입니다.'
        this.authDialog.endMessage = '계약승인이 완료 되었습니다. 보관함으로 이동합니다.'
        // 승인 시 블록체인 인증 창을 활성화 하기 전 기업일 경우 잔여 포인트 확인
        this.confirmCurrPoint()
      }else if (changeStatus === 'CN') {
        this.authDialog.title = '계약승인 거부'
        this.authDialog.authUserText = '계약 수신자'
        this.authDialog.warningText = '블록체인 인증이 완료되어야 승인거부가 완료 됩니다.'
        this.authDialog.changeStatusText = '계약승인 거부 중입니다.'
        this.authDialog.endMessage = '계약승인이 거부되었습니다.'
        this.purCertInfo.hash = 'asdfasdfafa'
        this.$refs.rejectMessage.open()
      } else if (changeStatus === 'CA') {
        this.authDialog.title = '계약요청 취소'
        this.authDialog.authUserText = '계약 요청자'
        this.authDialog.warningText = '블록체인 인증이 완료되어야 계약요청이 취소됩니다.'
        this.authDialog.changeStatusText = '계약요청 취소중입니다.'
        this.authDialog.endMessage = '계약요청이 취소되었습니다. 보관함으로 이동합니다.'
        if(this.cPass !== '') {
          this.divideDownOrchangeStatus()
        } else {
          this.$refs.chainPass.open()
        }
      } else if (changeStatus === 'downloadCC') {
        this.authDialog.title = '계약승인'
        this.authDialog.authUserText = '계약 수신자'
        this.authDialog.warningText = '원본계약서 확인과 계약승인을 위해 두번의 블록체인 인증이 필요합니다.'
        this.authDialog.changeStatusText = '계약서 다운로드 요청중입니다.'
        if(this.cPass !== '') {
          this.divideDownOrchangeStatus()
        } else {
          this.$refs.chainPass.open()
        }
      } else if (changeStatus === 'downloadPC') {
        this.authDialog.title = '검토승인'
        this.authDialog.authUserText = '검토 수신자'
        this.authDialog.warningText = '원본계약서 확인과 검토승인을 위해 두번의 블록체인 인증이 필요합니다.'
        this.authDialog.changeStatusText = '계약서 다운로드 요청중입니다.'
        if(this.cPass !== '') {
          this.divideDownOrchangeStatus()
        } else {
          this.$refs.chainPass.open()
        }
      } else if (changeStatus === 'PC') {
        this.authDialog.title = '검토승인'
        this.authDialog.authUserText = '검토 수신자'
        this.authDialog.warningText = '블록체인 인증이 완료되어야 검토승인 후 계약요청이 완료됩니다.'
        this.authDialog.changeStatusText = '검토 승인 후 계약요청 중입니다.'
        this.authDialog.endMessage = '검토승인후 계약요청이 완료 되었습니다. 미처리함으로 이동합니다.'
        if(this.cPass !== '') {
          this.divideDownOrchangeStatus()
        } else {
          this.$refs.chainPass.open()
        }
      } else if (changeStatus === 'PA') {
        this.authDialog.title = '검토요청 취소'
        this.authDialog.authUserText = '검토 수신자'
        this.authDialog.warningText = '블록체인 인증이 완료되어야 검토요청이 취소됩니다.'
        this.authDialog.changeStatusText = '검토요청 취소 중입니다.'
        this.authDialog.endMessage = '검토요청이 취소되었습니다. 보관함으로 이동합니다.'
        if(this.cPass !== '') {
          this.divideDownOrchangeStatus()
        } else {
          this.$refs.chainPass.open()
        }
      } else if (changeStatus === 'PN') {
        this.authDialog.title = '검토승인 거부'
        this.authDialog.authUserText = '검토 수신자'
        this.authDialog.warningText = '블록체인 인증이 완료되어야 검토승인 거부가 완료 됩니다.'
        this.authDialog.changeStatusText = '검토승인 거부 중입니다.'
        this.authDialog.endMessage = '검토승인이 거부되었습니다. 보관함으로 이동합니다.'
        if(this.cPass !== '') {
          this.divideDownOrchangeStatus()
        } else {
          this.$refs.chainPass.open()
        }
      }
    },
    confirmCurrPoint () {
      if (this.signal === 'BROKER') {
        this.$refs.loading.start('포인트 확인 중입니다.')
        confirmCurrPoint({ chainAddress: this.authForm.chainAddress }).then(response => {
          this.$refs.loading.end()
          var result = response.rdata.isPoint
          if (result === true) {
            this.$refs.chainPass.open()
          } else {
            this.$confirm('포인트가 부족합니다. 계약 승인을 위해 포인트를 충전 후에 다시 이용해주세요.', '포인트 부족', {
              distinguishCancelAndClose: true,
              confirmButtonText: '요금 충전창으로 이동',
              cancelButtonText: '취소'
            }).then(() => {
              this.$router.push({ name: 'taxInfo' })
            }).catch(action => {
            })
          }
        }).catch(() => {
        })
      } else if (this.signal === 'PERSONAL') {
        this.$refs.chainPass.open()
      }
    },
    print () {
      window.print()
    },
    downloadAttachFile (item) {
      if(this.contractDetailInfo.chainPassword !== '') {
        this.downloadFileInfo = item
        this.$refs.loading.start('첨부파일 다운로드 요청중입니다.')
        this.downloadParam.chainAddr = this.contractDetailInfo.chainAddress
        this.downloadParam.chainPass = this.contractDetailInfo.chainPassword
        this.downloadParam.downloadUrl = this.downloadFileInfo.fileLink
        this.downloadParam.contractNumber = this.contractDetailInfo.contractNumber
        this.downloadParam.contractStatus = this.contractDetailInfo.contractStatus
        this.downloadParam.contractFileName = this.downloadFileInfo.fileName
        this.downloadParam.gubun = "DA"
        downloadFile(this.downloadParam).then(response => {
          // poer.close()
          this.$refs.loading.end()
          if (response.rdata.rcode === 20000) {
            var downloadFileName = encodeURIComponent(response.rdata.downFileName)
            window.open(
              this.url.confirmDownloadURL +
              '/' + this.downloadParam.gubun +
              '/' + response.rdata.convId +
              '/' + this.downloadParam.downloadUrl,
              '_blank')
            this.getContractRecord()
          } else {
            this.$refs.confirm.open('alert', '계약서 다운로드', '계약서 다운로드 요청에 실패했습니다. ( error : ' + response.rdata.rmessage + ' )')
          }
        })
      }else {
        this.$refs.confirm.open('alert', '계약서 다운로드', '미리보기를 한 후 다운로드가 가능해집니다.')
      }
    },
    checkSignType () {
      if(this.contractDetailInfo.signType === 1) {
        this.$refs.pubCert.open()
      }else{
        this.$refs.chainPass.open()
      }
    },
    // [2차 블록체인 인증] 마지막 블록체인 인증 창에서 확인 눌렀을 때
    submitAuthChain () {
      var changeStatusParam = this.paramsForChangeStatus()
      // 계약 승인과 승인 이외의 처리 프로세스 분리(검토승인 포함)
      if (this.authDialog.changeStatus === 'CC') {
        this.$refs.loading.start('블록체인 인증 중입니다.')
        verifyChain(changeStatusParam).then(response => {
          this.$refs.loading.end()
          if (response.rdata.rcode === 20000) {
            if (this.signal === 'BROKER') {
              // 여기는 기업 돈차감하는거 필요함
              this.changeStatusApprove(changeStatusParam)
              // alert(this.contractDetailInfo.ctrType.code)
            } else if (this.signal === 'PERSONAL') {
              if (this.contractDetailInfo.ctrType.code === 'CD0020') {
                this.changeStatusApprove(changeStatusParam)
              } else {
                this.PGCall()
              }
            }
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open('alert', '계약 승인', '블록체인 인증에 실패했습니다. ( 실패이유 - ' + response.rdata.rmessage + ' )')
          } else {
            this.$refs.confirm.open('alert', '계약 승인', '블록체인 인증에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.')
          }
        }).catch(e => {
          console.log(e)
        })
      } else {
        if (this.authDialog.changeStatus === 'PC') {
          // 검토 승인일 경우
          this.changeStatusForReviewApprove(changeStatusParam)
        } else {
          // 계약/검토 승인 외 상태변경 처리
          var confirmTitle = '계약상태 변경'
          var confirmText = '계약 상태를 변경하시겠습니까?'
          if(this.authDialog.changeStatus === 'CN') {
            confirmTitle = "승인거부"
            confirmText = "승인거부를 하시겠습니까?"
          }else if(this.authDialog.changeStatus === 'CA') {
            confirmTitle = "요청취소"
            confirmText = "요청취소를 하시겠습니까?"
          }
          this.$refs.confirm.open('confirm', confirmTitle, confirmText).then(() => {
            this.changeStatus(changeStatusParam)
          })
        }
      }
    },
    // [상태변경] 승인을 제외한 상태변경
    changeStatus (changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText)

      changeStatus(changeStatusParam).then(response => {
        this.$refs.loading.end()
        if (response.rdata.rcode === 20000) {
          this.$refs.confirm.open('confirm', this.authDialog.title, this.authDialog.endMessage).then(() => {
            this.$router.push({ name: 'storage' })
          })
          this.sheet = false
        } else if (response.rdata.rcode === 30011) {
          this.$refs.confirm.open('alert', this.authDialog.title, this.authDialog.title + '에 실패했습니다. ( 실패이유 - ' + response.rdata.rmessage + ' )')
        } else {
          this.$refs.confirm.open('alert', this.authDialog.title, this.authDialog.title + '에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.')
        }
      }).catch(e => {
        console.log(e)
        this.$refs.loading.end()
        this.$refs.confirm.open('alert', this.authDialog.title, this.authDialog.title + '에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.')
      })
    },
    changeStatusForReviewApprove (changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText)
      changeStatusForReviewApprove(changeStatusParam).then(response => {
        this.$refs.loading.end()
        if (response.rdata.rcode === 20000) {
          this.chainAuthDialogVisible = false
          this.$refs.confirm.open('confirm', this.authDialog.title, this.authDialog.endMessage).then(() => {
            this.$router.push({ name: 'storage' })
          })
        } else if (response.rdata.rcode === 30011) {
          this.$refs.confirm.open('alert', this.authDialog.title, this.authDialog.title + '에 실패했습니다. ( 실패이유 - ' + response.rdata.rmessage + ' )')
        } else {
          this.$refs.confirm.open('alert', this.authDialog.title, this.authDialog.title + '에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.')
        }
      }).catch(e => {
        console.log(e)
        this.$refs.loading.end()
        this.$refs.confirm.open('alert', this.authDialog.title, this.authDialog.title + '에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.')
      })
    },
		payEndMove(page) {
      if(page === 'write') {
				location.reload()
			}else if(page === 'storage') {
				this.$router.push({ name: 'storage' })
			}
		},
    // [상태변경] 승인
    changeStatusApprove (changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText)
      changeStatusForApprove(changeStatusParam).then(response => {
        this.$refs.loading.end()
        if (response.rdata.rcode === 20000) {

          this.chainAuthDialogVisible = false
          var orgTotalPoint = response.rdata.orgTotalPoint
          var companyAmount = response.rdata.companyAmount
          if (this.signal === 'BROKER') {
            this.usePoint = companyAmount
            this.totalPoint = orgTotalPoint
            this.payEnd = true
          } else if (this.signal === 'PERSONAL') {
            this.$refs.confirm.open('confirm', this.authDialog.title, this.authDialog.endMessage).then(()=>{
              this.$router.push({ name: 'storage' })
            })
          }
        } else if (response.rdata.rcode === 30011) {
          this.$refs.confirm.open('alert', this.authDialog.title, this.authDialog.title + '에 실패했습니다. ( 실패이유 - ' + response.rdata.rmessage + ' )')
        } else {
          this.$refs.confirm.open('alert', this.authDialog.title, this.authDialog.title + '에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    PGCall () {
			this.paymentBuyer = this.$store.state.user.userid
			this.paymentEmail = this.$store.state.user.useremail
			this.$refs.pgRequest.open()
    },
    // 상태변경을 위한 데이터를 만들어주는 함수 (중복이 되어서 따로 만듦)
    paramsForChangeStatus () {
      var changeStatusParam = {}
      changeStatusParam.chainAddr = this.contractDetailInfo.chainAddress
      changeStatusParam.chainPass = this.contractDetailInfo.chainPassword
      changeStatusParam.ctrNo = this.contractDetailInfo.contractNumber
      changeStatusParam.ctrSeq = this.contractDetailInfo.id
      changeStatusParam.ctrStat = this.authDialog.changeStatus
      changeStatusParam.rejectMsg = this.contractDetailInfo.rejectMsg
      if (this.authDialog.changeStatus === 'CC' || this.authDialog.changeStatus === 'PC' || this.authDialog.changeStatus === 'CN') {
        if (this.isWmAttach) {
          changeStatusParam.pdfFileName = this.$store.state.app.convertPdfName
        } else {
          changeStatusParam.pdfFileName = this.convertedInfo.convertedCtrFileName
        }
      }
      return changeStatusParam
    },
    close () {
      this.sheet = false
    },
    purCertResult: function(vid, errorMessage, sign, certPEM) {
      this.errorMessage = errorMessage
      if(vid) {
        if(this.chainPassCheck === 'Y') {
          this.$refs.chainPassCheck.open()
        }else{
          this.submitAuthChain()
          this.dialogIdtest = false
          this.sheet = false
        }
      }else{
        this.$refs.confirm.open('alert', "공동인증", errorMessage)
      }
    },
    divideDownOrchangeStatus () {
      if (this.authDialog.changeStatus === 'downloadCC' || this.authDialog.changeStatus === 'downloadPC') {
        this.$refs.loading.start('계약서 다운로드 중입니다.')
        this.downloadParam.chainAddr = this.contractDetailInfo.chainAddress
        this.downloadParam.chainPass = this.contractDetailInfo.chainPassword
        this.downloadParam.downloadUrl = this.contractDetailInfo.contractFileLink
        this.downloadParam.contractNumber = this.contractDetailInfo.contractNumber
        this.downloadParam.contractFileName = this.contractDetailInfo.contractFileName
        this.downloadParam.contractStatus = this.contractDetailInfo.contractStatus
        this.downloadParam.receiverAddress = this.contractDetailInfo.receiverAddress
        this.downloadParam.gubun = "PV"
        downloadFile(this.downloadParam).then(response => {
          this.$refs.loading.end()
          if (response.rdata.rcode === 20000) {
            this.convertedInfo.downloadTempPath = response.rdata.downloadTempPath
            this.convertedInfo.convertedCtrFileName = response.rdata.convId
            this.convertedInfo.contractNumber = this.contractDetailInfo.contractNumber
            this.getContractRecord()
            this.$refs.ctrReqeustDialog.open()
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open('alert', '계약서 다운로드', '계약서 다운로드 요청에 실패했습니다. ( 실패이유 - ' + response.rdata.rmessage + ' )')
          } else {
            this.$refs.confirm.open('alert', '계약서 다운로드', '계약서 다운로드 요청에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.')
          }
        }).catch(e => {
          this.$refs.loading.end()
          this.$refs.confirm.open('alert', '계약서 다운로드', '계약서 다운로드 요청에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요.')
          console.log(e)
        })
      } else if (this.authDialog.changeStatus === 'preview') {
				this.downloadAuthChain()
			} else {
        this.submitAuthChain()
      }
    },
    chainPassResult: function(pass) {
      this.contractDetailInfo.chainPassword = pass
      this.divideDownOrchangeStatus()
    },
    rejectResult: function(msg) {
      this.contractDetailInfo.rejectMsg = msg
      this.checkSignType()
    },
    pgResult: function(seq) {
      var changeStatusParam = this.paramsForChangeStatus()
      changeStatusParam.pgSeq = seq
      this.changeStatusApprove(changeStatusParam)
    },
    goList(data) {
      if(data !== undefined && data !== '') {
        // this.usePoint = data.companyAmount
        // this.totalPoint = data.orgTotalPoint
        // this.payEnd = true
        if(this.contractDetailInfo.contractStatus === 'CR') {
          this.$refs.confirm.open('confirm', '계약승인', '계약이 승인되었습니다.').then(()=>{
            this.$router.push({ name: 'storage' })
          })
        }else {
          this.$refs.confirm.open('confirm', '검토승인', '계약이 검토승인되었습니다.').then(()=>{
            this.$router.push({ name: 'storage' })
          })
        }
      } else {
        if(this.contractDetailInfo.contractStatus === 'CR') {
          this.$refs.confirm.open('confirm', '계약승인', '계약이 승인되었습니다.').then(()=>{
            this.$router.push({ name: 'storage' })
          })
        }else {
          this.$refs.confirm.open('confirm', '검토승인', '계약이 검토승인되었습니다.').then(()=>{
            this.$router.push({ name: 'storage' })
          })
        }
      }
    },
    listGo() {
      this.$router.push({ name: 'storage' })
    },
    emailResend() {
      this.$refs.emailResend.open()
    },
    CtrRecord(stat) {
      if(stat === 'CR') {
        return '계약요청'
      }else if(stat === 'CC') {
        return '계약승인'
      }else if(stat === 'CA') {
        return '계약요청 취소'
      }else if(stat === 'CN') {
        return '승인거부'
      }else if(stat === 'PV') {
        return '미리보기'
      }else if(stat === 'PR') {
        return '검토요청'
      }else if(stat === 'PN') {
        return '검토거부'
      }else if(stat === 'PC') {
        return '검토승인'
      }else if(stat === 'DW') {
        return '다운로드'
      }else if(stat === 'LA') {
        return '열람인증'
      }
    },
    getContractRecord() {
      getContractRecord({ ctrSeq: this.contractSeq }).then(response => {
        if (response.rdata.rcode === 20000) {
          this.contractHistory = response.rdata.contractHistory
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<style scoped>
</style>
